import { X } from 'lucide-react';
import { ENTITY_META } from './entityMeta';
import type { EntityType } from '@/api/search';
import type { StatusValue } from './StatusFilter';

export interface ActiveFilterChipsProps {
  types: EntityType[];
  removeType: (t: EntityType) => void;
  customerId: string | null;
  customerName?: string;
  clearCustomer: () => void;
  dateFrom: string;
  dateTo: string;
  clearDate: () => void;
  status: StatusValue;
  resetStatus: () => void;
}

function Chip({ children, onRemove }: { children: React.ReactNode; onRemove: () => void }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-medium text-slate-700">
      {children}
      <button
        type="button"
        onClick={onRemove}
        className="rounded-full p-0.5 hover:bg-slate-200"
        aria-label="Remove filter"
      >
        <X className="h-2.5 w-2.5" />
      </button>
    </span>
  );
}

export function ActiveFilterChips(p: ActiveFilterChipsProps) {
  const anyActive =
    p.types.length > 0 || p.customerId !== null || p.dateFrom || p.dateTo || p.status !== 'active';
  if (!anyActive) return null;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-1">
      <span className="text-[10px] uppercase text-slate-400">Active filters:</span>
      {p.types.map((t) => (
        <Chip key={t} onRemove={() => p.removeType(t)}>Type: {ENTITY_META[t].label}</Chip>
      ))}
      {p.customerId !== null && p.customerName && (
        <Chip onRemove={p.clearCustomer}>Customer: {p.customerName}</Chip>
      )}
      {(p.dateFrom || p.dateTo) && (
        <Chip onRemove={p.clearDate}>
          Date: {p.dateFrom ? new Date(p.dateFrom).toLocaleDateString() : '…'}
          {' → '}
          {p.dateTo ? new Date(p.dateTo).toLocaleDateString() : '…'}
        </Chip>
      )}
      {p.status !== 'active' && (
        <Chip onRemove={p.resetStatus}>
          {p.status === 'include_inactive' ? 'Inactive included' : 'Deleted included'}
        </Chip>
      )}
    </div>
  );
}
